export default __webpack_public_path__ + "static/media/em-banner1-en.101e82f7.png";